import { createEntityWithState } from 'module/Redux/Common';
import { Route } from 'module/Model/Routes';

type Payloads = {
  set: Route;
};

type State = Route | null;

export const lastGridRouteEntity = createEntityWithState<Payloads, State>()(
  'lastGridRoute',
  null,
  {},
  {
    set: (s, p) => p,
  }
);



// WEBPACK FOOTER //
// ./src/module/Redux/Router/lastGridRouteEntity.ts